"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cloneDeep = require('clone-deep');
/**
 * Class for cloning objects.
 */
class Clonable {
    /**
     * Creates a deep clone of the object.
     */
    clone() {
        let newInstance = Object.create(this.constructor.prototype);
        Object.getOwnPropertyNames(this).forEach(property => {
            if (property === "clone") {
                newInstance[property] = this[property].clone();
            }
            else {
                newInstance[property] = cloneDeep(this[property]);
            }
        });
        return newInstance;
    }
}
exports.default = Clonable;
